import { action } from "satcheljs";

export const unifiedInboxDisabledWhileActive: () => {} = action("unifiedInboxDisabledWhileActive");
